import React from 'react';
import { getCurrentPage } from 'utils/getParams';
import { commonHeadScripts } from 'helpers/scripts/headScripts';
// eslint-disable-next-line import/no-extraneous-dependencies
import _get from 'lodash.get';
import { getSiteConfig } from 'reduxUtils/modules/common';
import { updatePrebidFlag } from 'helpers/ads/redux';
import { loadPageAdCode } from 'helpers/ads/revenueRedux';
import {
  setAdsConfig,
  getKeyvaluesNav,
  checkJarvisAdsConfigForSS,
  getAdsNavSubsecsForVideoshow,
} from 'helpers/ads/utils';
import generateVideoshowSchema from 'helpers/seo/getVideoshowSchema';
import Layout from 'components_v2/desktop/Layout';
import { loadLayoutDataVideo } from 'reduxUtils/modules_v2/layout';
import Videoshow from './Videoshow';
import {
  getCustomDimension45,
  fireGA4Script,
  getIncrementalMaxAge,
} from '../../../../utils/common';
import {
  TOI_LIVE_DOMAIN,
  TOI_LIVE_MOBILE_DOMAIN,
  STAGING_URL_PREFIX,
  TOI_IMAGE_DOMAIN,
  VIDEO_TIMESTAMP_THRESHOLD,
  WEBVIEW_PLATFORM,
  BUSINESS_TOI,
  DESKTOP_PLATFORM,
} from '../../../../constants';
import { TOI_BASE_DOMAIN } from '../../../../components/Html/constants';
import { loadVideoshowData, loadRelatedArticlesData } from '../../redux';
import getCwvReportingObj from '../../../../utils/getCwvReportingObj';

const pageName = 'videoshow';

async function action(context, params) {
  const { clientRouting } = context;

  let status = 200;
  let redirect = false;

  const dataPromiseArray = [];

  const isWapView = false;
  let showMiniTv = false;
  let hideAdCude = true;
  const imageInfo = [];
  const cd8 = '';
  let cd55 = '';

  const isBrowser = typeof window === 'object';
  const isServer = typeof window === 'undefined';

  const contextParams = context.params;
  let state = context.store.getState();

  const isAppView = state.isFrmapp;

  const { pathname } = context;
  if (pathname && pathname.includes('/cryptocurrency')) {
    showMiniTv = false;
    hideAdCude = true;
  }

  let overlayMode = false;
  if (isBrowser) {
    window.historyArray = window.historyArray || [];
    for (let i = window.historyArray.length - 1; i >= 0; i -= 1) {
      const item = window.historyArray[i];
      if (item && item.indexOf('videoshow') === -1) {
        overlayMode = true;
      }
    }
  }

  const categoryForGA = 'WEB-videoshow';

  if (isBrowser) {
    window.categoryForGA = categoryForGA;
    window.categoryForSearchGA = 'WEB-TOI-Videoshow';

    const sectionsList = contextParams['0'].split('/');
    if (sectionsList && sectionsList.length > 2) {
      setAdsConfig({ subSection: sectionsList[2] });
    }
  }

  const newParams = {
    ...params,
    curpg: getCurrentPage(context.query),
    fullPath: `/videoshow/${params.msid}.cms`,
    isWapView,
    skipSubSections: isWapView,
    skipNavigationCalls: isWapView && context.clientRouting && overlayMode,
    hideMobileTopBar: isWapView && context.clientRouting && overlayMode,
    templateName: 'videoshow',
    isAppView,
  };

  // Layout data calls start
  // const layoutDataPromises = context.store.dispatch(
  //   loadLayoutDataVideo(newParams),
  // );
  // dataPromiseArray.push(layoutDataPromises);
  if (!state.header.data || !state.footer_v2.data) {
    dataPromiseArray.push(
      context.store.dispatch(loadLayoutDataVideo(newParams)),
    );
  }
  // Layout data calls ends

  if (isServer || clientRouting) {
    dataPromiseArray.push(context.store.dispatch(loadVideoshowData(newParams)));
  }

  if (isServer) {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  // wait for responses on server side
  if (isServer) {
    await Promise.all(dataPromiseArray);
  }

  // get updated state
  state = context.store.getState();

  const widgetsPromiseArray = [];
  const raurl = _get(state, `videoshow.videoshowData.relatedArticleUrl`, '');
  const searchStr = _get(state, `videoshow.videoshowData.pwa_meta.key`, '');
  if (!state.videoshow.relatedarticles && raurl) {
    widgetsPromiseArray.push(
      context.store.dispatch(loadRelatedArticlesData(searchStr, raurl)),
    );
  }

  if (widgetsPromiseArray.length > 0 && isServer) {
    await Promise.all(widgetsPromiseArray);
  }

  state = context.store.getState();

  const leadVideoData =
    state.videoshow &&
    state.videoshow.videoshowData &&
    state.videoshow.videoshowData.items &&
    Array.isArray(state.videoshow.videoshowData.items) &&
    state.videoshow.videoshowData.items.length > 0
      ? state.videoshow.videoshowData.items[0]
      : '';
  if (leadVideoData && leadVideoData.unixtimesstamp) {
    cd55 = getCustomDimension45(leadVideoData.unixtimesstamp);
  }

  const title = leadVideoData && leadVideoData.hl ? leadVideoData.hl : '';
  const dataAvailable = state.videoshow && state.videoshow.videoshowData;
  let isPrime = !!state.isPrime;
  const videoDetailData = state?.videoshow?.videoshowData;
  const videoItemData = videoDetailData?.items;
  let isNoad = false;

  if (
    videoItemData &&
    Array.isArray(videoItemData) &&
    videoItemData.length > 0 &&
    videoItemData[0].isNoAd === 'true'
  ) {
    isNoad = true;
  }

  let turnOffVideoAds = false;
  if (
    state?.videoshow?.videoshowData?.metaInfo?.AdServingRules ===
    'Turnoff Video Ads'
  ) {
    turnOffVideoAds = true;
  }

  const primeTemplate =
    leadVideoData &&
    (leadVideoData.primeTempleate || leadVideoData.primeTemplate);

  if (primeTemplate) {
    status = 404;
    isPrime = true;
  }

  if (isServer && !dataAvailable) {
    status = 404;
  }

  let cwvReportingInfo = {};

  try {
    cwvReportingInfo = getCwvReportingObj({
      dataAvailable,
      state,
      platform: DESKTOP_PLATFORM,
      browsingPlatform: isAppView ? WEBVIEW_PLATFORM : DESKTOP_PLATFORM,
      businessProperty: BUSINESS_TOI,
      pageName: 'videoshow',
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('issue in cwvReportingInfo');
    cwvReportingInfo = {};
  }
  // const imgsize = leadVideoData && leadVideoData.imgsize;
  const leadImgId = leadVideoData && leadVideoData.imageid;

  if (leadImgId) {
    imageInfo.push(`${TOI_IMAGE_DOMAIN}/photo/79638690.cms`);

    imageInfo.push(
      `${TOI_IMAGE_DOMAIN}/thumb/msid-${leadImgId},width-600,resizemode-4/${leadImgId}.jpg`,
    );
  }

  const showPreload = imageInfo instanceof Array && imageInfo.length > 0;

  if (
    isBrowser &&
    dataAvailable &&
    state.videoshow &&
    state.videoshow.videoshowData &&
    state.videoshow.videoshowData.pwa_meta
  ) {
    let canonicalUrl = state.videoshow.videoshowData.pwa_meta.canonical
      ? state.videoshow.videoshowData.pwa_meta.canonical
      : '';
    if (
      typeof window !== 'undefined' &&
      typeof canonicalUrl === 'string' &&
      canonicalUrl
    ) {
      if (
        canonicalUrl &&
        canonicalUrl.indexOf('timesofindia.indiatimes.com') > -1 &&
        window.location.href.indexOf('?') === -1
      ) {
        canonicalUrl = canonicalUrl.split('timesofindia.indiatimes.com');
        const urlInBrowser = window.location.pathname;
        if (
          Array.isArray(canonicalUrl) &&
          canonicalUrl.length > 1 &&
          canonicalUrl[1].toLowerCase() !== urlInBrowser.toLowerCase()
        ) {
          try {
            const searchString = window.location.href.split('?')[1];
            // history.push(canonicalUrl[1]);
            window.location.href = `${canonicalUrl[1]}${
              searchString ? `?${searchString}` : ''
            }`;
          } catch (e) {
            window.location.href = canonicalUrl[1];
          }
        }
      }
    }
  }

  // Server Side redirection for the incorrect URL
  if (
    !isBrowser &&
    dataAvailable &&
    state.videoshow &&
    state.videoshow.videoshowData &&
    state.videoshow.videoshowData.pwa_meta &&
    state.videoshow.videoshowData.pwa_meta.canonical
  ) {
    let canonicalUrl = state.videoshow.videoshowData.pwa_meta.canonical;
    let currentDomain = false;
    if (canonicalUrl.indexOf('timesofindia.indiatimes.com') > -1) {
      currentDomain = 'timesofindia.indiatimes.com';
    } else if (canonicalUrl.indexOf('toidev.indiatimes.com') > -1) {
      currentDomain = 'toidev.indiatimes.com';
    }

    //-- Need to added this validation from API side info need to add --/
    if (
      videoItemData &&
      Array.isArray(videoItemData) &&
      videoItemData.length &&
      videoItemData[0].isShort === 'true' &&
      videoDetailData.pwa_meta &&
      videoDetailData.pwa_meta.canonical
    ) {
      const shortTakesUrl = videoDetailData.pwa_meta.canonical.replace(
        '/videoshow/',
        '/shorttakes/',
      );
      status = 301;
      redirect = `${shortTakesUrl}`;
    }

    if (
      canonicalUrl &&
      currentDomain &&
      pathname.indexOf('?') === -1 //&&
      // state.videoshow.videoData.seoData.data.multipublish !== 1
    ) {
      canonicalUrl = canonicalUrl.split(currentDomain);
      const urlPath = pathname;
      const stgVideoshowURL =
        STAGING_URL_PREFIX + canonicalUrl[1].toLowerCase();
      if (
        canonicalUrl[1].toLowerCase() !== urlPath.toLowerCase() &&
        stgVideoshowURL !== urlPath.toLowerCase()
      ) {
        let finalQueryString = '';
        if (Object.keys(context.query).length > 0) {
          const queryString = new URLSearchParams();
          Object.keys(context.query).forEach(key =>
            queryString.append(key, context.query[key]),
          );
          finalQueryString = queryString.toString();
          finalQueryString = `?${finalQueryString}`;
        }
        status = 301;
        redirect = `${isWapView ? TOI_LIVE_MOBILE_DOMAIN : TOI_LIVE_DOMAIN}${
          canonicalUrl[1]
        }${finalQueryString}`;
      }
    }
  }

  const getComponent = pageTitle => {
    if (typeof window === 'undefined' && !dataAvailable) {
      return (
        <div>
          Something went wrong. Click{' '}
          <a href="https://timesofindia.indiatimes.com">here</a> to browse TOI
        </div>
      );
    }
    const prebidObj = _get(
      state,
      `common.siteConfig.prebid.templates.videoshow`,
    );
    context.store.dispatch(updatePrebidFlag(prebidObj));

    const breadCrumbData = _get(state, 'header.data.navigation.breadcrumbs');
    if (pageTitle && breadCrumbData && typeof window === 'undefined') {
      breadCrumbData.push({
        label: pageTitle,
        link: '',
      });
    }
    return (
      <Layout
        layoutClass="layout_type_2"
        title={pageTitle}
        params={newParams}
        query={Object.keys(context.query).length ? context.query : {}}
        layoutType=""
        hideStickyBackToTop
        rhs={false}
        adPosition="masthead"
        showAdBlockerInINEU
        showTimesTop10
        // hideAdBlockerDetector //comment this to add adblocker
        refreshFBNAd
        hideBreadcrumAtBottom
        pageType="videoshow"
        pageTypeWithVersion="videoshow"
        hideAds={isNoad}
        showCovid19PopUp
        msid={newParams.msid}
        showMiniTv={showMiniTv}
        hideAdCude={hideAdCude}
        bannerMsid={_get(state, 'videoshow.data.bannerMsid', '')}
        navigation={state.header.data && state.header.data.navigation}
        hideAffiliatesFloatingNudge
        templateName="videoshow"
        gutterAdCode={_get(state, 'revenue.data.ads.layout.gutter', undefined)}
      >
        <Videoshow
          routeParams={newParams}
          clientRouting={clientRouting}
          isAppView={isAppView}
          categoryForGA={categoryForGA}
          msid={newParams && newParams.msid}
          skipAds={isNoad || turnOffVideoAds}
          sectionadsCode={
            state?.videoshow?.videoshowData?.navsubsecs?.subsec2?.subsecmsid2
          }
          isPrime={isPrime}
          translationData={state?.translationConfig?.data}
          breadCrumbData={breadCrumbData}
        />
      </Layout>
    );
  };

  const videoPlayerJsVersion = state?.common?.siteConfig?.videoshow
    ?.videoPlayerJsVersion
    ? state?.common?.siteConfig?.videoshow?.videoPlayerJsVersion
    : 1;

  const videoShowCommonHeadScripts = [
    <script
      src="https://timesofindia.indiatimes.com/video_comscore_api/version-3.cms"
      type="text/javascript"
      id="video_comscore_js"
    />,
    <script
      type="text/javascript"
      src="https://imasdk.googleapis.com/js/sdkloader/ima3.js"
      id="ima3_sdk_js"
    />,
    <script
      type="text/javascript"
      src="https://tvid.in/player/4.0.3/cpl.js"
      id="tvid_sdk_js"
    />,
    <script
      src={`${TOI_BASE_DOMAIN}/toi_player_js_v4/minify-1,version-${videoPlayerJsVersion}.cms`}
      type="text/javascript"
      id="toi_player_js_v4"
    />,
  ];

  const getAdsTargetingObj = () => {
    if (state && state.videoshow && state.videoshow.videoshowData) {
      const articleId = params.msid;
      const metaKeywords = state.videoshow.videoshowData?.pwa_meta?.key || '';
      const specialId =
        state.videoshow.videoshowData?.metaInfo?.SpecialID || '';

      let contentUrl = `${TOI_LIVE_DOMAIN}${pathname}`;
      const navsubsecs = state.videoshow.videoshowData?.navsubsecs;
      const adsNavSubsecs = getAdsNavSubsecsForVideoshow(navsubsecs);
      const otherKeysValue = state.videoshow.videoData?.adkeyValues || {};
      contentUrl = contentUrl?.replace('/videos/', '/') || '';
      const navKeyObj = getKeyvaluesNav(adsNavSubsecs, contentUrl);
      const adConfig = {
        Tmpl_SCN: 'videoshow',
        Channel: 'toi',
        Hyp1: specialId,
        ...navKeyObj,
      };
      if (typeof window === 'undefined') {
        checkJarvisAdsConfigForSS({
          jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
          isWapView,
          ...adConfig,
        });
      }
      return {
        Article_ID: articleId,
        Meta_Keywords: metaKeywords,
        Content_URL: contentUrl,
        ...adConfig,
        ...otherKeysValue,
      };
    }
    return null;
  };
  if (typeof window !== 'undefined') {
    fireGA4Script({ vmsid: params.msid });
  }

  const adsTargetingObj = getAdsTargetingObj();

  if (adsTargetingObj && typeof window === 'undefined' && status === 200) {
    await context.store.dispatch(loadPageAdCode(adsTargetingObj, 'web'));
    // get updated state
    state = context.store.getState();
  }

  const revWidgets = _get(state, 'revenue.data.widgets', {});
  const isNewGam = _get(revWidgets, 'isNewGam', false);

  const getSeoData = async () => {
    const seoObj =
      state.videoshow.videoshowData && state.videoshow.videoshowData.pwa_meta
        ? state.videoshow.videoshowData.pwa_meta
        : {};

    seoObj.datePublished = _get(seoObj, 'dlseo', '');

    seoObj.dateModified = _get(seoObj, 'luseo', '');

    seoObj.title = _get(seoObj, 'ogtitle', '');

    if (seoObj.keyhundred) {
      seoObj.title = `${seoObj.keyhundred}: ${seoObj.title}`;
    }

    seoObj.description = _get(seoObj, 'desc', '');

    seoObj.keywords = _get(seoObj, 'key', '');

    seoObj.amplink = _get(seoObj, 'amphtml', '');

    seoObj.canonical = _get(seoObj, 'canonical', '');

    seoObj.ogimage = _get(seoObj, 'ogimg', '');

    if (
      state.videoshow &&
      state.videoshow.videoshowData &&
      state.videoshow.videoshowData.items &&
      Array.isArray(state.videoshow.videoshowData.items) &&
      state.videoshow.videoshowData.items.length > 0
    ) {
      const { unixtimesstamp } = state.videoshow.videoshowData.items[0];
      if (unixtimesstamp < VIDEO_TIMESTAMP_THRESHOLD) {
        // timestamp older than 31st dec 2015 TOIPR-90328
        seoObj.amplink = '';
        seoObj.amphtml = '';
        seoObj.noindexnofollow = true;
      }
    }

    let schemaObj = [];

    // const liveBroadcastIds =
    //   typeof state?.common?.siteConfig?.videoshow?.liveBroadcastIds === 'string'
    //     ? state.common.siteConfig.videoshow.liveBroadcastIds.split(',')
    //     : '';
    const liveBroadcastSchema =
      state.videoshow &&
      state.videoshow.videoshowData &&
      state.videoshow.videoshowData.metaInfo &&
      state.videoshow.videoshowData.metaInfo.VIDEOTYPE
        ? state.videoshow.videoshowData.metaInfo.VIDEOTYPE
        : '';

    if (leadVideoData) {
      schemaObj = [
        generateVideoshowSchema(leadVideoData, seoObj, liveBroadcastSchema),
      ];
    }

    if (schemaObj && schemaObj.length > 0) {
      seoObj.schema = schemaObj;
    }
    return seoObj;
  };

  const getMaxAge = () => {
    let maxAge = _get(state, `videoshow.videoshowData.maxAge`, '');
    if (maxAge) {
      return maxAge;
    }
    maxAge = 14400;
    let modifiedTime = _get(
      state,
      `videoshow.videoshowData.pwa_meta.modified`,
      '',
    );
    if (!modifiedTime) {
      modifiedTime = _get(
        state,
        `videoshow.videoshowData.pwa_meta.publishtime`,
        '',
      );
    }
    const modifiedTimestamp = Math.floor(new Date(modifiedTime).getTime());
    if (!(state && state.isPrime) && modifiedTimestamp) {
      maxAge = getIncrementalMaxAge(modifiedTimestamp);
    }
    return maxAge;
  };

  const agencyName =
    leadVideoData && leadVideoData.source ? leadVideoData.source : '';

  // const gtmIDForOptimisely = ['GTM-54ZCD8R'];
  return {
    chunks: ['videoshowdesktop'],
    title,
    seoData: await getSeoData(),
    maxAge: getMaxAge(),
    gaData: {
      dimension9: pageName,
      dimension8: cd8,
      dimension35: title,
      dimension5: agencyName,
      dimension55: cd55,
      dimension61: state.videoshow?.videoData?.seoData?.data?.Contenttype
        ? state.videoshow?.videoData?.seoData?.data?.Contenttype
        : '',
    },
    status,
    component: getComponent(title),
    adsTargetingObj,
    isMaxImagePreview: true,
    isMaxVideoPreview: true,
    isVideoScriptsHasHighPriority: true,
    preconnectDomains: [],
    // gtmIDList: gtmIDForOptimisely,
    headTags: [...commonHeadScripts, ...videoShowCommonHeadScripts],
    showPreload,
    singleURL: true,
    imageInfo,
    baseScriptTimeout: -1,
    redirect,
    preloadVideoDependencies: true,
    skipRouteAds: isNoad,
    edgeCacheTag: params.msid,
    videoPlayerJsVersion,
    skipPageViewGAOnLoad: true,
    isNewGam,
    skipColumbiaScript: _get(revWidgets, 'skipCTN', false),
    addDebugBearScript: false,
    isJsLoadingOptimized: true, // will set this flag true for experiment for a section
    debugBearScript: null,
    cwvReportingInfo,
  };
}

export default action;
